import React from "react";
import styles from "../styles/terms.module.css";

const TermsOfService = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.pageHeader}>Terms of Service</h1>

        <div className={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By using the Job Assistant software and associated services
            ("Service"), you agree to be bound by these Terms of Service
            ("Terms"), our Privacy Policy, and all applicable laws. If you do
            not agree with these Terms, please discontinue using the Service.
          </p>
        </div>

        <div className={styles.section}>
          <h2>2. Use License & Conduct</h2>
          <p>
            We grant you a limited, non-exclusive, non-transferable license to
            use the Service solely for personal, non-commercial job searching.
          </p>
          <p>You agree not to:</p>
          <ul>
            <li>
              Misuse the Service, including excessive automation or scraping
              that violates LinkedIn’s User Agreement.
            </li>
            <li>Use the Service for any unlawful or prohibited purpose.</li>
            <li>Reverse engineer, decompile, or disassemble the software.</li>
            <li>Share your account credentials with others.</li>
          </ul>
          <div className={styles.highlightBox}>
            <h3>Important Notice Regarding LinkedIn</h3>
            <p>
              This Service is not affiliated with or endorsed by LinkedIn
              Corporation. You must comply with LinkedIn’s User Agreement.
              Excessive or abusive use of automation may lead to restrictions on
              your LinkedIn account. We are not responsible for such actions
              taken by LinkedIn.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <h2>3. Service Operation & Limitations</h2>
          <ul>
            <li>
              The Service runs locally on your computer. Your resume and
              credentials are not stored on our servers.
            </li>
            <li>
              Free plans are limited (e.g., 5 applications). Paid plans have
              credit limits and daily usage recommendations.
            </li>
            <li>
              We do not guarantee job offers or interviews through the Service.
            </li>
            <li>
              We may modify, suspend, or discontinue the Service at any time.
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>4. Payments and Refunds</h2>
          <p>
            Paid plans provide application credits. Payments are handled by
            third-party processors (e.g., Razorpay, Stripe). Payments are
            generally non-refundable once credits are used. Refund requests for
            unused plans may be considered within 7 days of purchase.
          </p>
        </div>

        <div className={styles.section}>
          <h2>5. Disclaimer of Warranties</h2>
          <p>
            The Service is provided “as is” without warranties of any kind,
            including merchantability, fitness for a particular purpose, or
            non-infringement.
          </p>
        </div>

        <div className={styles.section}>
          <h2>6. Limitation of Liability</h2>
          <p>
            We are not liable for any indirect or consequential damages
            resulting from the use of the Service. Our total liability shall not
            exceed the amount you paid in the last 6 months.
          </p>
        </div>

        <div className={styles.section}>
          <h2>7. Account Termination</h2>
          <p>
            We may suspend or terminate your access without prior notice if you
            violate these Terms. Upon termination, your right to use the Service
            will cease immediately.
          </p>
        </div>

        <div className={styles.section}>
          <h2>8. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India, without regard to
            conflict of law principles.
          </p>
        </div>

        <div className={styles.section}>
          <h2>9. Changes to Terms</h2>
          <p>
            We may update these Terms at any time. Significant changes will be
            notified to users. Continued use of the Service means acceptance of
            updated Terms.
          </p>
        </div>

        <div className={`${styles.section} ${styles.contactSection}`}>
          <h2>Contact Us</h2>
          <p>
            For any questions regarding these Terms, contact us at{" "}
            <a href="mailto:help.jobassistant@gmail.com">
              help.jobassistant@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
